import React from 'react';

const ReportsList = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Reportes y Estadísticas</h1>
          <p className="text-gray-600">Genera reportes sobre evolución de los estudiantes</p>
        </div>
        <button className="bg-primary-500 hover:bg-primary-600 text-white px-4 py-2 rounded-lg font-medium">
          Generar Reporte
        </button>
      </div>

      {/* Content */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
        <div className="text-center">
          <svg className="w-16 h-16 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <h3 className="text-lg font-medium text-gray-900 mb-2">Sistema de Reportes</h3>
          <p className="text-gray-600 mb-6">Este módulo está en desarrollo. Aquí podrás generar reportes académicos y estadísticas.</p>
          <div className="text-sm text-gray-500">
            Próximamente: Reportes académicos, estadísticas de rendimiento, gráficos interactivos, exportación a PDF y más.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsList;